/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React from 'react';
import { Checkmark } from '@mummssoftware/icons';

export const PrnDetailCell = (props: any) => {
  const { data } = props;
  return data.prn ? (
    <>
      <Checkmark style={{ fontSize: '1.25rem' }} />
    </>
  ) : (
    <></>
  );
};

export default PrnDetailCell;
